import API_URL from '../config/api';
import { apiFetch } from '../utils/apiFetch';

export const sendInvoiceEmail = async (invoiceId: string, token: string, email?: string) => {
  const res = await apiFetch(`${API_URL}/invoices/${invoiceId}/send`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: email ? JSON.stringify({ email }) : undefined
  });

  let data: any = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    throw new Error(data?.message || data?.error || `Failed to send invoice (${res.status})`);
  }

  return data;
};
